(() => {
      const root = document.querySelector('.hp-ranking');
      if (!root) return;
      const endings = [...root.querySelectorAll('details.ending')];
      root.querySelector('#spoiler-controls').hidden = false;
      root.querySelector('#open-endings').addEventListener('click', () => endings.forEach(el => { el.open = true; }));
      root.querySelector('#close-endings').addEventListener('click', () => endings.forEach(el => { el.open = false; }));
      root.querySelectorAll('a[data-open-ending]').forEach(link => link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target) || !target.matches('details.ending > summary')) return;
        target.parentElement.open = true;
        // The hash targets the focusable summary, so native navigation scrolls AND focuses it.
      }));
      // Local CustomEvents only. No network, GA4, cookies, or persistent identifiers.
      endings.forEach(el => el.addEventListener('toggle', () => {
        document.dispatchEvent(new CustomEvent('ranking-preview-interaction', {detail: {kind: 'ending_toggle', work: el.dataset.rankingWork, open: el.open}}));
      }));
    })();
